import {Component, ViewChild, Output, EventEmitter, Inject} from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { NmdpWidget } from '@nmdp/nmdp-login';
import { FileRecordService } from '../records/file-record.service';
import { SessionSizeObject } from '../records/file-record';
import { ModalConfig } from '../modal/modal-config';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
const URL = '/upload/file/upload';
import { AppComponent } from '../app.component';
import 'rxjs/add/operator/map';

@Component({
  selector: 'uploader-component',
  styleUrls: [ './uploader.component.css'],
  templateUrl: './uploader.component.html'
})

export class UploaderComponent {

  private filecnt: Number;
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;
  private modalTitle: string;
  private modalContent: SafeHtml;
  private modalConfig: ModalConfig;
  sessionSizeObject: SessionSizeObject;

  public uploader: FileUploader = new FileUploader({
    url: URL,
    queueLimit: 26,
    autoUpload: false
  });

  @Output()
  uploaded: EventEmitter<string> = new EventEmitter();

  @ViewChild('sizeError')
  private modalSizeError: ModalComponent;
  @ViewChild('typeError')
  private modalTypeError: ModalComponent;

  getFileCnt() {
    return this.filecnt;
  }

  getModalTitle() {
    return this.modalTitle;
  }
  constructor(private readonly fileRecordService: FileRecordService,
              private readonly sanitizer: DomSanitizer,
              @Inject(NmdpWidget) private readonly loginWidget: NmdpWidget,
              private readonly appComponent: AppComponent) {
    this.fileRecordService.getSessionContentSize().then(sessionSize =>  {
      if (sessionSize) {
        this.filecnt = sessionSize.totalSessionFileCount;
      }
    });
  }

  ngOnInit(): void {
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    this.uploader.onAfterAddingAll = (fileItems) => this.onAfterAddingAll(fileItems);
    this.uploader.onCompleteAll = () => this.onCompleteAll();
  }
  onChange(event: any): void {
  }


  onAfterAddingAll(files: FileItem[]): void {
      this.fileRecordService.getSessionContentSize().then(sessionSize =>  {
      if (sessionSize) {
        this.sessionSizeObject = sessionSize;
        const sumNumberOfFiles = this.sessionSizeObject.totalSessionFileCount + files.length;
        this.filecnt = sumNumberOfFiles;
        if ( this.filecnt > 25 ) {
            this.filecnt = this.sessionSizeObject.totalSessionFileCount;
        }
        let sumSizeOfFiles = this.sessionSizeObject.totalSessionUploadSize;
        for (let file of files) {
          sumSizeOfFiles += file.file.size;
        }
        if (sumSizeOfFiles >= 104857600 || sumNumberOfFiles > 25) {
          this.modalConfig = {
            small: true,
            okBtnTitle: 'Continue',
            okBtnCssClass: 'btn btn-primary hml-button-validate-only',
            cancelBtnTitle: '',
            footerMessage: ''
          };
          this.modalTitle = `Warning! Maximum session capacity exceeded!`;
          this.modalSizeError.open(this.modalConfig);
          this.uploader.cancelAll();
          this.uploader.clearQueue();
        } else {
          this.loginWidget.getAccessToken()
            .then((data) => {
              this.uploader.authToken = 'Bearer ' + data;
              this.loginWidget.markActive(this.appComponent.processTimeout.bind(this));
              this.uploader.uploadAll();
            })
            .catch((error) => {
              console.log('Promise rejected with ' + JSON.stringify(error));
            });
        }
      }
    });
  }


  public getSessionSize(files: FileItem[]): any {
    // this.hasBaseDropZoneOver = e;
  }


  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    // let data = JSON.parse(response); //success server response
  }

  onCompleteAll() {
    this.uploaded.emit('complete');
  }

  onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    if (response.indexOf('CSV file uploaded is too large.') > 0) {
      this.modalConfig = {
        small: true,
        okBtnTitle: 'Continue',
        okBtnCssClass: 'btn btn-primary hml-button-validate-only',
        cancelBtnTitle: '',
        footerMessage: ''
      };
      this.modalTitle = `Warning! Maximum session capacity exceeded!`;
      this.modalSizeError.open(this.modalConfig);
    }
    if (response.indexOf('Wrong file Type.') > 0) {
      this.modalConfig = {
        small: true,
        okBtnTitle: 'Continue',
        okBtnCssClass: 'btn btn-primary hml-button-validate-only',
        cancelBtnTitle: '',
        footerMessage: ''
      };
      this.modalTitle = `Warning! Invalid File Type.  Valid file types are XML, HML and CSV.`;
      this.modalTypeError.open(this.modalConfig);
    }
    if (response.indexOf('Invalid filename.') > 0) {
      this.modalConfig = {
        small: true,
        okBtnTitle: 'Continue',
        okBtnCssClass: 'btn btn-primary hml-button-validate-only',
        cancelBtnTitle: '',
        footerMessage: ''
      };
      this.modalTitle = `Warning! Invalid filename.`;
      this.modalTypeError.open(this.modalConfig);
    }
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public modalContinueClick(e: any): void {

  }
}
